
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup } from 'react-bootstrap'
// import { momentHelper } from '../helpers'
// import SelectDate from 'component/element/SelectDate'
import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
// import FontAwesome from 'react-fontawesome'
// import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'

import '../report.css'
// import { connect } from 'react-redux';

class ReportWaitingQuotation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      activePage:1,
      opt:'person',
      optList:[{label:'เจ้าของรถ(บุคคล)',value:'person'},{label:'เจ้าของ(บริษัท)',value:'company'},{label:'บริษัทประกัน',value:'insurer'}],
      opt1:'',
      opt1List:[{label:'-- เลือก --',value:''}],
      data:[]
    }
    this.refTableId = 'ReportWaitingQuotation-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.opt,this.state.opt1)
      this.loadOpt1List(this.state.opt)
    }
  }

  getNumberFormat(value,digit=2) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  loadOpt1List(opt) {
    let opt1List = []
    opt1List.push({label:'-- เลือก --',value:''})
    ReportStore.loadPendingApprovedquotationCustomerList(opt,(result)=>{
      result.data.forEach((item,index)=>{
          opt1List.push({label:item.name,value:item.name})
      })
      this.setState({opt1List:opt1List,opt1:''})
    })
  }

  loadData(opt='',opt1='') {
    this.setState({loading:true})
    ReportStore.loadReportPendingApprovedQuotation(opt,opt1,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  renderBody() {
    let {data} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={12}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.claim_no}</td>
              <td className='text-center'>{item.insurer_name}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.fixing_count}</td>
              <td className='text-right'>{this.getNumberFormat(item.wage_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.part_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_wage)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_part)}</td>
              <td className='text-center'>{item.entrance_date}</td>
              <td className='text-center'>{item.appointment_date}</td>
            </tr>
        )
      )
    }
  }

  renderTable() {
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-bordered-solid table-hover'>
          <thead>
            <tr>
              <th className='text-center' style={{minWidth:'20px',width:'20px'}}>ลำดับ</th>
              <th className='text-center' style={{minWidth:'80px',width:'80px'}}>เลขที่<br/>ใบสั่งซ่อม</th>
              <th className='text-center' style={{minWidth:'80px',width:'80px'}}>เลขที่เคลม<br/>หมายเลขแจ้ง</th>
              <th className='text-center' style={{minWidth:'110px',width:'110px'}}>ประกันภัย</th>
              <th className='text-center' style={{minWidth:'90px',width:'90px'}}>เลขทะเบียน</th>
              <th className='text-center' style={{minWidth:'90px',width:'90px'}}>จำนวน<br/>รายการซ่อม</th>
              <th className='text-center' style={{minWidth:'90px',width:'90px'}}>ราคา<br/>เสนอค่าแรง</th>
              <th className='text-center' style={{minWidth:'90px',width:'90px'}}>ราคา<br/>เสนอค่าอะไหล่</th>
              <th className='text-center' style={{minWidth:'90px',width:'90px'}}>ราคา<br/>อนุมัติค่าแรง</th>
              <th className='text-center' style={{minWidth:'90px',width:'90px'}}>ราคา<br/>อนุมัติค่าอะไหล่</th>
              <th className='text-center' style={{minWidth:'80px',width:'80px'}}>วันที่รับรถเข้า</th>
              <th className='text-center' style={{minWidth:'80px',width:'80px'}}>วันที่นัดส่งรถ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={5} className='text-right'>ยอดรวมสุทธิ</th>
              <th className='text-center'>{this.getNumberFormat(this.getSummary('fixing_count'),0)}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('wage_amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('part_amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('approved_wage'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('approved_part'))}</th>
              <th colSpan={2} className='text-right'></th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onOptChange(val) {
    this.setState({
      opt: val.value
    })
    this.loadOpt1List(val.value)
  }

  onOpt1Change(val) {
    this.setState({
      opt1: val.value
    })
    this.loadData(this.state.opt,val.value)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานงานซ่อมรอส่งเรื่อง.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    let url = ''
    let param = 'PrintReportWaitingQuotation&customerType='+this.state.opt+'&q='+this.state.opt1

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  renderToolbar() {
    return(
      <Form inline>
        <div style={{ width: '150px', display: 'inline-block' }}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.opt}
            options={this.state.optList}
            onChange={this.onOptChange.bind(this)}
          />
        </div>
        <div style={{ width: '200px', display: 'inline-block', marginLeft:'5px' }}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.opt1}
            options={this.state.opt1List}
            onChange={this.onOpt1Change.bind(this)}
          />
        </div>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  render() {
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderTable()}
          {/*this.renderPaging()*/}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportWaitingQuotation.defaultProps = {
  show : false
}

export default ReportWaitingQuotation;


// WEBPACK FOOTER //
// ./src/view/report/fixing/ReportWaitingQuotation.js